/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimeEntryStatus } from './TimeEntryStatus';
import {
    TimeEntryStatusFromJSON,
    TimeEntryStatusFromJSONTyped,
    TimeEntryStatusToJSON,
} from './TimeEntryStatus';

/**
 * 
 * @export
 * @interface TimeEntryStatusesResponse
 */
export interface TimeEntryStatusesResponse {
    /**
     * 
     * @type {Array<TimeEntryStatus>}
     * @memberof TimeEntryStatusesResponse
     */
    statuses: Array<TimeEntryStatus>;
    /**
     * 
     * @type {any}
     * @memberof TimeEntryStatusesResponse
     */
    count: any | null;
}

/**
 * Check if a given object implements the TimeEntryStatusesResponse interface.
 */
export function instanceOfTimeEntryStatusesResponse(value: object): value is TimeEntryStatusesResponse {
    if (!('statuses' in value) || value['statuses'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function TimeEntryStatusesResponseFromJSON(json: any): TimeEntryStatusesResponse {
    return TimeEntryStatusesResponseFromJSONTyped(json, false);
}

export function TimeEntryStatusesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeEntryStatusesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'statuses': ((json['statuses'] as Array<any>).map(TimeEntryStatusFromJSON)),
        'count': json['count'],
    };
}

export function TimeEntryStatusesResponseToJSON(value?: TimeEntryStatusesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'statuses': ((value['statuses'] as Array<any>).map(TimeEntryStatusToJSON)),
        'count': value['count'],
    };
}

